// extracted by css-extract-rspack-plugin
module.exports =  {"root":"WorkspaceOpportunityDetailsSheet__root___t0HZn"};